import { VoucherFieldName, VoucherFieldKey } from "./types";

//separate 1000s with commas
export const separateThousands = (value: string) => {
  let normalizedValue = value;

  return normalizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

//strip 0 from the beginning of the string
export const stripLeadingZero = (value: string) => {
  let normalizedValue = value;

  if (normalizedValue[0] === '0') {
    normalizedValue = '';
  }

  return normalizedValue;
};

export const getInputName = (index: number, name: VoucherFieldKey): VoucherFieldName =>
  `vouchers.${index}.${name}` as const;
